import React, { useEffect } from 'react';
import { SET_VALUE } from '../formReducer';

interface Props {
    formId: string;
    formName: string;
    formDispatch: any;
    item: {
        name: string;
        value: any;
    };
}

const HiddenFieldComponent: React.FC<Props> = ({ formDispatch, formId, formName, item: { name: fieldId, value } }) => {
    useEffect(() => {
        // Initialize reducer state for both form keys (id and name), mirroring platform-v2 behavior
        formDispatch({ type: SET_VALUE, payload: { value, fieldId, formId } });
        formDispatch({ type: SET_VALUE, payload: { value, fieldId, formId: formName } });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};

export default HiddenFieldComponent;
